import React from 'react';
export function SocialProofSection() {
  const comments = [{
    avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
    name: 'Carmen S.',
    time: 'Hace 2 horas',
    text: 'Día 3: Por fin un paseo sin que me duela el hombro. No me lo creo.'
  }, {
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    name: 'Javier R.',
    time: 'Hace 5 horas',
    text: 'Acabo de cruzarme con otro perro y el mío ni se ha inmutado. ¡Funciona!'
  }, {
    avatar: 'https://randomuser.me/api/portraits/women/68.jpg',
    name: 'Elena M.',
    time: 'Ayer',
    text: 'Ojalá lo hubiera tenido hace 2 años. Mi Golden hoy parecía otro en el ascensor.'
  }];
  return <section className="pt-6 pb-12 px-5" data-id="element-272">
      <div className="max-w-lg mx-auto" data-id="element-273">
        <div className="flex flex-col gap-4 mb-6" data-id="element-274">
          {comments.map((comment, index) => <div key={index} className="glass-teal rounded-2xl p-5 shadow-sm" data-id="element-275">
              <div className="flex items-center justify-between mb-3" data-id="element-276">
                <div className="flex items-center gap-3" data-id="element-277">
                  <img src={comment.avatar} alt={comment.name} className="w-10 h-10 rounded-full object-cover shadow-sm border border-teal/30" data-id="element-278" />
                  <div data-id="element-279">
                    <p className="font-bold text-white text-sm" data-id="element-280">
                      {comment.name}
                    </p>
                    <p className="text-white/40 text-xs" data-id="element-281">{comment.time}</p>
                  </div>
                </div>
              </div>
              <p className="text-white/90 text-[15px] leading-relaxed" data-id="element-282">
                {comment.text}
              </p>
            </div>)}
        </div>

        <p className="text-white/50 text-sm text-center font-medium" data-id="element-283">
          Visto en la comunidad: +450 comentarios positivos esta semana.
        </p>
      </div>
    </section>;
}